<script lang="ts">
  import { pop } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";

  onMount(() => {
    if (import.meta.env.DEV) console.log("About mounted.");
  });
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px] min-[480px]:hidden"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Om Mina sidor
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="max-w-[680px] p-[32px] max-mobile:px-[8px] text-[14px] text-[#606060]"
  >
    <img src="/graphics/logo-large.svg" alt="logo" class="w-[124px]" />
    <p class="pt-[24px] pb-[16px]">
      Mina sidor är framtagen och utvecklad i Stockholm hos Parkando AB.
      Målsättningen med Mina sidor är att underlätta administration av dina
      parkeringsbehov. Vi tar gärna emot feedback till <a
        class="underline text-[#181818]"
        href="mailto:support@parkando.se"
      >support@parkando.se</a>.
    </p>
    <p>Version <strong>{import.meta.env.VITE_MYPAGES_TAG}</strong></p>
  </div>
</div>
